module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "div1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "w100 print-dv1"
  }, [_c('div', [_c('span', [_vm._v("客户编号:" + _vm._s(_vm.PageBody.AgentCode))]), _vm._v(" "), _c('span', [_vm._v("销售下单编号:" + _vm._s(_vm.PageHeader.OrderCode))]), _vm._v(" "), _c('span', [_vm._v("发货通知单编号:" + _vm._s(_vm.PageHeader.Code))])])]), _vm._v(" "), _c('div', {
    staticClass: "w100 print-dv1"
  }, [_c('div', [_c('span', [_vm._v("销售下单时间:" + _vm._s(_vm.PageHeader.OrderTime))])])]), _vm._v(" "), _c('table', {
    staticClass: "print-table"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("客户名称:" + _vm._s(_vm.PageBody.AgentName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("供货日期:")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "pt10"
  }, [_vm._v("客户地址:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.PageBody.DefaultAgentAddress))])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "pt10"
  }, [_vm._v("联系人:" + _vm._s(_vm.PageBody.ContactName))]), _vm._v(" "), _c('div', [_vm._v("联系方式:" + _vm._s(_vm.PageBody.ContactTel))])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.PageBody.ListProduct), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ProCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ProName))]), _vm._v(" "), _c('td', {
      staticClass: "txtCss"
    }, _vm._l((item.PackDetail), function(PackDetail) {
      return _c('div', {
        staticClass: "dpDvCss"
      }, [_vm._v(_vm._s(PackDetail.ProName) + " - " + _vm._s(PackDetail.ProNum) + _vm._s(PackDetail.ProNaturalUnitName))])
    })), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "line-height": "15px"
      }
    }, [_vm._v(_vm._s(item.ProModel))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ProNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Remark))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ScatteredNum))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
  }))]), _vm._v(" "), _c('table', {
    staticClass: "print-table",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pt10"
  }, [_vm._v("物流单号：")]), _vm._v(" "), _c('div', {
    staticClass: "pt10"
  }, [_vm._v("寄送方式：" + _vm._s(_vm.PageBody.SendModeName) + " -- " + _vm._s(_vm.PageBody.PayModeName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "pt10"
  }, [_vm._v("本单货物收货信息：\n            "), _c('span', {
    staticClass: "fwb"
  }, [_vm._v("收货人姓名")]), _vm._v(" "), _c('span', {
    staticClass: "print-sp-tx",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.PageBody.Consignee))]), _vm._v("，\n            "), _c('span', {
    staticClass: "fwb"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('span', {
    staticClass: "print-sp-tx",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.PageBody.ConsigneeTel))])]), _vm._v(" "), _c('div', {
    staticClass: "fwb"
  }, [_vm._v("收货地址:\n            "), _c('span', [_vm._v(_vm._s(_vm.PageBody.ConsigneeAddress))])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "7px 0px",
      "color": "#000"
    }
  }, [_vm._v("\n      ★货物交接流程：物流公司运输司机拿提货单及货物签收单到发货地点，联系发货人，双方按货物签收单上数量清点无误后签字确认；发货仓库出具货物签收单一式三份，发货仓库留底一份，运输司机持剩余两份货物签收单与货物一起运输到指定收货地址，两份货物签收单由收货人签字确认后，一份由收货方留底，一份由运输司机带走做回执单。★\n    ")])]), _vm._v(" "), _c('div', [_c('el-row'), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin": "20px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isOk
    },
    on: {
      "click": _vm.printPage
    }
  }, [_vm._v("打印")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回列表页")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print-head"
  }, [_c('h2', {
    staticClass: "print-big-title"
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": require("../../assets/iqeq.png")
    }
  }), _vm._v("福建智趣互联科技股份有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "print-sm-title"
  }, [_vm._v("货物签收单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%",
      "height": "30px"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("产品编号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%",
      "overflow": "hidden"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("包含单品")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("型号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("散数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("拼箱箱号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("拼箱数量")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt10"
  }, [_vm._v("\n            依据双方合同协议约定，本次下单合计交付货物件数为\n            "), _c('span', {
    staticClass: "print-sp-tx"
  }), _vm._v("件,\n            "), _c('span', {
    staticClass: "print-sp-tx",
    staticStyle: {
      "width": "200px"
    }
  }), _vm._v("包装方式。\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "fwb",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("验收日期：")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "fwb"
  }, [_vm._v("客户确认签字(验收人):")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "fwb"
  }, [_vm._v("验货：\n          ")]), _vm._v(" "), _c('div', [_vm._v("收货方授权收货人员在本单货物签收单据上签字，则即视为收货方对供货方所供货物型号、数量、质量等符合合同或协议约定。\n          ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "fwb"
  }, [_vm._v("物流公司运输司机签字:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "pt10 fwb"
  }, [_vm._v("供货单位：福建智趣互联科技股份有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "pt10 fwb"
  }, [_vm._v("地址：福建省福州市鼓楼区软件大道89号福州软件园G区10号楼 ")]), _vm._v(" "), _c('div', {
    staticClass: "pt10 fwb"
  }, [_vm._v("邮编：350003     电话:0591-87800515")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "fwb"
  }, [_vm._v("本单货物发货人签字:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0531b4ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SendGoods/SendGoodsForCKPage.vue
// module id = 1369
// module chunks = 1